export const PROGRAMS_ROUTE = '/programs';
export const PROGRAMS_ID_PARAM = '/:programId';
export const PROGRAMS_PROGRESS_ID_PARAM = '/:programProgressId';
export const PROGRESS_REPORT_ROUTE = '/progressReport';
export const PROGRAMS_COMPLETED_ROUTE = '/programs/completed';
export const PROGRAM_DETAIL_COMPLETED = '/:programId/completed/:programProgressId';
